export function pickLocalizedName(language, name, nameArabic, nameHebrew) {
  if (language === "ar" && nameArabic) return nameArabic;
  if (language === "he" && nameHebrew) return nameHebrew;
  return name;
}
